import { render, staticRenderFns } from "./modal-deletion-list.vue?vue&type=template&id=76395a15&scoped=true&"
import script from "./modal-deletion-list.vue?vue&type=script&lang=js&"
export * from "./modal-deletion-list.vue?vue&type=script&lang=js&"
import style0 from "./modal-deletion-list.vue?vue&type=style&index=0&id=76395a15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76395a15",
  null
  
)

export default component.exports